/**
 * type---1:路由跳转；2：链接跳转；3：接口获取跳转链接 4：转发分享
 */
import http from '@/components/http';
const process = [
    {
        name: "开始投保",
        code: 'STP',
        route: '/',
        type: 1,
    },
    {
        name: "获取测算项",
        code: 'GCI',
        route: 'product-premium',
        url: "/product/premium",

        type: 1,
    },
    {
        name: "被保人确认",
        code: 'SIC',
        route: 'insurer-confirm-video',
        url: "/product/insurer-confirm-video",

        type: 1,
    },
    {
        name: "投保人确认",
        code: "SHC",
        route: "holder-confirm-video",
        url: "/product/holder-confirm-video",
        params: ["key"],
        type: 1,
    },
    {
        name: "被保人确认",
        code: 'FIC',
        route: 'insurer-confirm-video-new',
        url: "/product/insurer-confirm-video-new",

        type: 1,
    },
    {
        name: "投保人确认",
        code: "FHC",
        route: "holder-confirm-video-new",
        url: "/product/holder-confirm-video-new",
        params: ["key"],
        type: 1,
    },
    {
        name: "健康告知",
        code: 'GHN',
        route: 'product-healthy',
        url: "/product/healthy",

        type: 1,
    },
    {
        name: "健康告知",
        code: 'CHN',
        route: 'product-newHealthy',
        url: "/product/newHealthy",

        type: 1,
    },
    {
        name: "获取订单项",
        code: 'GOI',
        route: 'product-writeInform',
        url: "/product/writeInform",

        type: 1,
    },
    {
        name: "订单确认页",
        code: 'COI',
        route: 'product-ordersure',
        url: "/product/orderSure",

        type: 1,
    },
    {
        name: "下订单",
        code: 'BOP',
        route: 'product-cardPay',
        url: "/product/cardPay",

        type: 1,
    },
    {
        name: "快捷支付",
        code: 'FOP',
        route: 'product-pay',
        url: "/product/pay",

        type: 1,
    },
    {
        name: "支付",
        code: 'AOP',
        route: 'product-pay',
        url: "/product/pay",

        type: 1,
    },
    {
        name: "外链键告",
        code: 'HNU',
        route: '',
        url: "",
        type: 2,
    },
    {
        name: "综合支付",
        code: 'UOP',
        route: 'product-mergePay',
        url: "/product/mergePay",

        type: 1,
    },
    {
        name: "续保订单",
        code: 'RCI',
        route: 'product-renewal',
        url: "/product/renewal",

        type: 1,
    },
    {
        name: "疾病说明",
        code: 'GMI',
        route: 'product-manualCheck-collect',
        url: "/product/smartCheck/manualCheck/collect",

        type: 1,
    },
    {
        name: "补充疾病说明",
        code: 'GSQ',
        route: 'product-manualCheck-replenish',
        url: "/product/smartCheck/manualCheck/replenish",

        type: 1,
    },
    {
        name: "核保结论",
        code: 'GMR',
        route: 'product-manualCheck-conclusion',
        url: "/product/smartCheck/manualCheck/conclusion",

        type: 1,
    },
    {
        name: "等待支付",
        code: 'ISW',
        route: 'product-waitPay',
        url: "/product/waitPay",

        type: 1,
    },
    {
        name: "外链支付",
        code: 'LOP',
        type: 2,
    },
    {
        name: "外链支付-接口获取支付链接",
        code: 'TOP',
        type: 3,
    },
    {
        name: "聚合支付",
        code: 'MOP',
        route: 'product-mergePay',
        url: "/product/mergePay",

        type: 1,
    },
    {
        name: "投保人健康告知",
        code: 'GHH',
        route: 'product-holder-healthy',
        url: "/product/holderHealthy",

        type: 1,
    },
    {
        name: "银行签约",
        code: 'GSI',
        route: 'product-signUp',
        url: "/product/signUp",

        type: 1,
    },
    {
        name: "反洗钱",
        code: 'AML',
        route: 'product-smartCheck-antilaunder',
        url: "/product/smartCheck/checkInsure/antilaunder",

        type: 1,
    },
    {
        name: "风险评估",
        code: 'GRA',
        route: 'risk-assessment-question',
        url: "/product/riskAssessment/question",

        type: 1,
    },
    {
        name: "投保人签名",
        code: 'SHS',
        route: 'product-signature',
        params: [{ "name": "code", "value": "nextStep" }],
        url: "/product/signature",
        type: 1,
    },
    {
        name: "被保人签名",
        code: 'SIS',
        route: 'product-signature',
        params: [{ "name": "code", "value": "nextStep" }],
        url: "/product/signature",
        type: 1,
    },
    {
        name: "健康问卷",
        code: 'HNQ',
        route: 'product-healthQuestion-inisure',
        url: "/product/healthQuestion/inisure",
        type: 1,
    },
    {
        name: "个人税收居民身份声明文件",
        code: 'GOS',
        route: 'product-declaration',
        url: "/product/declaration",
        type: 1,
    },
    {
        name:"录音录像",
        code:'RQI',
        route: 'product-doubleRecording',
        url: "/product/offLine/doubleRecording",
        type: 1,
    },
    {
        name:"线下投保订单确认页",
        code:'OOI',
        route: 'product-infoSure',
        url: "/product/offLine/infoSure",
        type: 1,
    },
    {
        name:"问卷调查",
        code:'GRN',
        route: 'product-question-ergo',
        url: "/product/question/ergo",
        type: 1,
    },
    {
        name: "代投产品转发测算页",
        code: 'SCO',
        route: 'product-premium-assist',
        url: "/m/product/premium_assist",
        type: 4,
    },
    {
        name: "代投产品转发订单确认页",
        code: 'SCT',
        route: 'product-infoSure',
        url: "/m/product/offLine/infoSure",
        type: 4,
    },
    {
        name: "电话确权",
        code: 'TEL',
        route: 'product-confirm-permission',
        url: "/product/confirmPermission",
        type: 1,
    },
    {
        name:"投保资料上传",
        code:'SFU',
        route: 'product-insuranceInfoUpload',
        url: "/product/insuranceInfoUpload",
        type: 1,
    },
    {
        name:"投保信息确认",
        code:'NOI',
        route: 'product-newordersure',
        url: "/product/newOrderSure",
        type: 1,
    },
    {
        name:"投保资料上传",
        code:'SDP',
        route: 'product-newordersure-sign',
        url: "/product/newOrderSure/sign",
        type: 1,
    },
    {
        name: "投保人健康问卷",
        code: 'GHQ',
        route: 'product-healthQuestion-holder',
        url: "/product/healthQuestion/holder",
        type: 1,
    },
	{
	    name: "代理人告知",
	    code: 'ANQ',
	    route: 'product-healthQuestion-agent',
	    url: "/product/healthQuestion/agent",
	    type: 1,
	},
    {
        name: "单证确认",
        code: 'NDI',
        route: 'product-document-confirmation',
        url: "/product/documentConfirmation",
        type: 1,
    },
    {
        name: "支付确认",
        code: 'WOP',
        route: 'product-payTransfer-index',
        url: "/product/payTransfer",
        type: 1,
    }
]
const getProcess = (code, href) => {
    let result;
    process.forEach(o => {
        if (o.code == code) {
            result = o
        }
    })
    return result
}
const getStep = (name) => {
    let result;
    process.forEach(o => {
        if (o.route === name) {
            result = o
        }
    })
    return result
}
export default {
    getProcess,
    getStep
}